import type { AdminAiDownRating } from '@steado/admin-contract/ai-ratings';
import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { AiOpsScreen } from './AiOpsScreen';
import type { AiOpsSearch } from './ai-ops-search';
import { ratingDestination } from './ai-ratings-link';

const route = getRouteApi('/ai-operations');

export function AiOpsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: AiOpsSearch) => {
      void navigate({ replace: true, search: () => ({ days: next.days }) });
    },
    [navigate],
  );

  const navigateApp = useNavigate();

  const onOpenRating = useCallback(
    (row: AdminAiDownRating) => {
      const { userId, tab, session } = ratingDestination(row);
      void navigateApp({
        to: '/users/$userId',
        params: { userId },
        search: {
          ...(tab === undefined ? {} : { tab }),
          ...(session === undefined ? {} : { session }),
        },
      });
    },
    [navigateApp],
  );

  return <AiOpsScreen search={search} onSearchChange={onSearchChange} onOpenRating={onOpenRating} />;
}
